export const mapBadges = (badges: Array<string>): Array<string> =>
  badges.flatMap((badge) => {
    switch (badge) {
      case 'networkHome': {
        return 'network_home';
      }
      case 'notificationCenterWebVisionType': {
        return 'notification_center_web_vision_type';
      }
      case 'unreadChats': {
        return 'unseen_messages';
      }
      case 'unseenMessages': {
        return 'unseen_messages';
      }
      case 'meHub': {
        return 'me_hub';
      }
      case 'ncWeb': {
        return 'nc_web';
      }
      default:
        return [badge];
    }
  });
